import { SET_CHECKIN_ORDER } from './actions';
export const orderReducer = (state = null, action) => {
    if (action.type === SET_CHECKIN_ORDER) {
        return action.payload;
    }
    return state;
};
